import styled from 'styled-components';
import {Space} from 'antd';
import {typographyStyles} from '../../../../utils/styles';

const StyledTransactionDetails = styled(Space)`
  ${typographyStyles.footnote.description};
  
  align-items: center;
  color: ${props => props.theme.colors.neutral_10};
  display: flex;
  flex-direction: row;
  
  .date {
    color: ${props => props.theme.colors.neutral_10};
  }
  
  .price {
    font-weight: 500;
    
    &.danger-text {
      color: ${props => props.theme.colors.functional_danger};
    }
  }
`;

const StyledTransactionDetailsAvatar = styled.div`
  align-items: center;
  background-color: #F8F8F8;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  height: 42px;
  width: 42px;
  
  svg {
    height: 24px;
    width: 24px;

    path:not([fill-rule="evenodd"]) {
      fill: ${props => props.theme.colors.neutral_6};
    }
  }
`;

export {
  StyledTransactionDetails,
  StyledTransactionDetailsAvatar,
};
